import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import './documentation-service-overview.css';
import { useTranslation } from 'react-i18next';

const DocumentationServiceOverview = (props) => {
  const { t } = useTranslation();
  return (
    <div className={`documentation-service-overview-layout216 thq-section-padding ${props.rootClassName} `}>
      <div className='documentation-service-overview-max-width thq-section-max-width thq-flex-row'>
        <div className='thq-flex-column'>
          <img
            alt={props.featureImageAlt}
            src={props.featureImageSrc}
            className='documentation-service-overview-image1 thq-img-ratio-4-3'
          />
        </div>
        <div className='thq-flex-column documentation-service-overview-content'>
          <div className='documentation-service-overview-section-title thq-flex-column'>
            <h2 className='thq-heading-2'>
              {props.sectionTitle ?? (
                <Fragment>
                  <span className='documentation-service-overview-text13'>{t('documentationService.title')}</span>
                </Fragment>
              )}
            </h2>
            <p className='thq-body-large'>
              {props.featureDescription ?? (
                <Fragment>
                  <span className='documentation-service-overview-text14'>{t('documentationService.description')}</span>
                </Fragment>
              )}
            </p>
          </div>
          <div className='documentation-service-overview-actions thq-flex-row'>
            <a
              href='https://wa.me/818074115851?text=I%27m%20interested%20in%20Application%20Assistance'
              target='_blank'
              rel='noreferrer noopener'
              className='documentation-service-overview-button thq-button-filled'
            >
              <span className='thq-body-small'>
                {props.mainAction ?? (
                  <Fragment>
                    <span className='documentation-service-overview-text12'>{t('documentationService.contact')}</span>
                  </Fragment>
                )}
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

DocumentationServiceOverview.defaultProps = {
  featureImageAlt: 'Instant Notifications for Schengen Visa Appointments',
  featureImageSrc:
    'https://images.unsplash.com/photo-1509475826633-fed577a2c71b?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDJ8fGRvY3VtZW50YXRpb258ZW58MHx8fHwxNzUwMjM2NDEzfDA&ixlib=rb-4.1.0&w=1400',
  mainAction: undefined,
  sectionTitle: undefined,
  featureDescription: undefined,
  rootClassName: '',
};

DocumentationServiceOverview.propTypes = {
  featureImageAlt: PropTypes.string,
  featureImageSrc: PropTypes.string,
  mainAction: PropTypes.element,
  sectionTitle: PropTypes.element,
  featureDescription: PropTypes.element,
  rootClassName: PropTypes.string,
};

export default DocumentationServiceOverview;
